import { Group, Skeleton, Stack, Text } from '@mantine/core';
import React, { useEffect, useState } from 'react';
import { getChartRiwayatRedeem } from '../../services/report-gamification';
import { useQuery } from '@tanstack/react-query';
import BarChart from '../../components/elements/BarChart';
import Card from '../../components/elements/Card';
import dayjs from 'dayjs';

export default function ChartRiwayatRedeem() {
  const [dataChart, setDataChart] = useState([]);

  const fetchedDataRiwayatRedeem = useQuery({
    queryKey: [`chartRedeemHistory`],
    queryFn: () => getChartRiwayatRedeem(),
    enabled: true
  });

  const {
    data: dataRedeemHistory,
    isLoading,
    isError
  } = fetchedDataRiwayatRedeem;

  useEffect(() => {
    if (dataChart.length === 0 && dataRedeemHistory?.data?.data) {
      const _modifiedData = dataRedeemHistory?.data?.data
        .sort((a, b) => a.month - b.month)
        .map((item) => {
          return {
            ...item,
            label: dayjs()
              .month(item.month - 1)
              .format('MMMM')
          };
        });
      setDataChart(_modifiedData);
    }
  }, [dataRedeemHistory, dataChart]);

  const renderContent = () => (
    <BarChart
      chartKeys={['total']}
      chartLabels={['Total Redeemed']}
      chartColors={['#7B2183']}
      data={dataChart || []}
      loading={isLoading}
      isError={isError}
      onLoad={() => fetchedDataRiwayatRedeem.refetch()}
      chartLabelPosition="bottom"
      chartHeight={150}
    />
  );

  return (
    <Card flex={1} h={'100%'}>
      <Stack gap={'xs'} justify="space-between" h={'100%'}>
        <Group justify="space-between">
          <Text className="text-sm-semibold">Total Voucher Redemeed</Text>
          <Text className="text-xs-medium" c="gray">
            last 6 month
          </Text>
        </Group>

        {isLoading && <Skeleton height={150} />}
        {!isLoading && renderContent()}
      </Stack>
    </Card>
  );
}
